import { createBrowserRouter, Navigate } from 'react-router-dom';

// project-imports
import DashboardRoutes from './DashboardRoutes';
import AuthRoutes from './AuthRoutes';
import OffersRoutes from './OffersRoutes';
import LicensesRoutes from './LicensesRoutes';
import SettingRoutes from './SettingRoutes';
import OutletsRoutes from './OutletsRoutes';
import ReportsRoutes from './ReportsRoutes';
import MoviesRoutes from './MoviesRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    DashboardRoutes,
    AuthRoutes,
    OffersRoutes,
    LicensesRoutes,
    SettingRoutes,
    OutletsRoutes,
    ReportsRoutes,
    MoviesRoutes,
    { path: '*', element: <Navigate to="/login" replace /> }
  ],
  {
    basename: import.meta.env.VITE_APP_BASE_NAME
  }
);

export default router;
